<div
  class="color-block"
  *ngFor="let c of colors; let i = index; trackBy: byIndex"
  [ngStyle]="{ 'background-color': c }"
></div>
